import HhlaPageBase from './hhla-page-base'
import stimulus from 'lib/stimulus-instance'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import ParallaxController from 'frontend/controllers/parallax-controller'

stimulus.register('parallax', ParallaxController)

export default class HhlaWithBannerPage extends HhlaPageBase {
  static initVideo () {
    if (this.videoInitialized) return

    document.querySelectorAll('.video_container .video').forEach(el => clickToPlayWrap(el))
    this.videoInitialized = true
  }
}

HhlaWithBannerPage.init()
